<template>
  <div v-show="viewComment">
    <button
      v-b-modal="modalId"
      type="button"
      class="btn btn-sm btn-primary"
      @click="getComments(false)"
    >
      <i class="fas fa-comment" /> ({{ totalAllComments }}) Comments
    </button>
    <b-modal
      :id="modalId"
      :title="modalTitle"
      size="lg"
      hide-footer
    >
      <template #default="{ hide }">
        <div v-show="canComment">
          <vue-editor-clean-text :content.sync="newComment" />
          <div class="text-right mt-3">
            <b-button
              size="sm"
              variant="success"
              :disabled="!newComment"
              @click="addComment"
            >
              <b-spinner
                v-if="loading === true"
                small
              />
              Submit
            </b-button>
            <b-button
              size="sm"
              @click="hide()"
            >
              Cancel
            </b-button>
          </div>
          <hr>
        </div>
        <div>
          <div
            id="comments-list"
            class="mb-3"
          >
            <div
              v-for="comment in comments"
              :key="comment.id"
            >
              <div class="comment-details mb-2">
                <div class="author">
                  <i class="fa fa-fw fa-user" />
                  <strong> {{ comment.user.first_name }} {{ comment.user.last_name }}</strong>
                  <span class="timeat">{{ $moment(comment.created_at).fromNow() }}</span>
                  <a
                    v-show="userLoggedId === comment.user_id"
                    href="#"
                    class="ms-2"
                    @click="(event) => confirmDeleteComment(comment.id, event)"
                  ><i
                    class="fa fa-fw fa-trash-alt text-danger"
                  /></a>
                </div>
                <div
                  class="comment-content ms-3"
                  v-html="comment.comment"
                />
                <div class="replies-comment ms-4">
                  <div
                    v-for="reply in comment.replies_comment"
                    :key="reply.id"
                  >
                    <div class="author">
                      <i class="fa fa-fw fa-reply" />
                      <strong> {{ reply.user.first_name }} {{ reply.user.last_name }}</strong>
                      <span class="timeat">{{
                        $moment(reply.created_at).format('DD-MM-YYYY h:mm:ss a')
                      }}</span>
                    </div>
                    <div class="comment-content ms-3">
                      {{ reply.comment }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-pagination
            v-show="rows > perPage"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            size="sm"
            aria-controls="comments-list"
          />
        </div>
        <div v-if="loadingComments">
          <b-spinner
            type="grow"
            label="Loading comments"
            variant="primary"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
    name: 'ExpertCommentListBlock',
    props: {
        assignmentId: {
            type: Number,
            required: true,
        },
        assignmentCommentCount:{
            type: Number,
            default: 0,
        },
        expertName: {
            type: String,
            required: false,
            default: '',
        },
        projectStaffs: {
            type: [Object, Array],
            required: false,
            default () {
                return []
            },
        },
        userLoggedId: {
            type: [String, Number],
            required: false,
            default () {
                return ''
            },
        },
    },
    data () {
        return {
            loadingComments: false,
            newComment: '',
            loading: false,
            comments: [],
            commentsCount: 0,
            perPage: 10,
            currentPage: 1,
            totalAllComments: this.assignmentCommentCount,
            canComment: false,
            viewComment: true,
        }
    },
    computed: {
        modalId: function () {
            return `comment-modal-${this.assignmentId}`
        },
        modalTitle: function () {
            let title = 'List of comments'
            if (this.expertName) title += ' for ' + this.expertName
            title += ' (' + this.totalAllComments + ')'
            return title
        },
        rows: function () {
            return this.commentsCount
        },
        offset: function () {
            return this.currentPage * this.perPage - this.perPage
        },
    },
    watch: {
        currentPage: {
            handler: function (value) {
                this.getComments(false)
            },
        },
    },
    mounted () {
        /*if(this.assignmentCommentCount > 0) {
            this.getComments(true)
        }*/
        this.canComment = this.projectStaffs.some(staff => staff.user_id === this.userLoggedId)
    },
    methods: {
        addComment () {
            if (this.newComment !== '') {
                this.loading = true
                let reqData = { assignment_id: this.assignmentId, comment: this.newComment }
                axios.post(`/api/v2/comments`, reqData).then(res => {
                    this.loading = false
                    this.newComment = ''
                    //this.$bvModal.hide(this.modalId);
                    this.getComments(false)
                    this.$bvModal.msgBoxOk(`Add the comment successfully`)
                }).catch(err => {
                    //console.log('axios catch: ',err.response)
                    let errmsg = ''
                    if (err.response && err.response.data) {
                        errmsg = err.response.data.message
                    } else {
                        errmsg = 'An unknown error has occured'
                    }
                    One.helpers('jq-notify', {type: 'danger', icon: 'fa fa-times me-1', message: errmsg});
                    this.loading = false
                })
            } else {
                this.loading = false
                One.helpers('jq-notify', {type: 'danger', icon: 'fa fa-times me-1', message: 'Please add your comment'});
            }
        },
        confirmDeleteComment (commentId, e) {
            e.preventDefault()
            this.$bvModal.msgBoxConfirm('Are you sure to delete this comment?').then(value => {
                if (value) {
                    this.deleteComment(commentId)
                }
            }).catch(err => {
                // An error occurred
            })
        },
        deleteComment (commentId) {
            axios.delete(`/api/v2/comments/` + commentId).then(res => {
                this.getComments(false)
                this.$bvModal.msgBoxOk(`Delete the comment successfully`)
            }).catch(err => {
                //console.log('axios catch: ',err.response)
                let errmsg = ''
                if (err.response && err.response.data) {
                    errmsg = err.response.data.message
                } else {
                    errmsg = 'An unknown error has occured'
                }
                One.helpers('jq-notify', {type: 'danger', icon: 'fa fa-times me-1', message: errmsg});
            })
        },
        async getComments (onlyTotal) {
            try {
                this.loadingComments = true
                let params = {
                    assignment_id: this.assignmentId,
                }

                if (onlyTotal) {
                    params = {
                        ...params,
                        only_total: true,
                    }

                    let data = (await axios.get('/api/v2/comments', { params: params })).data.data
                    if (data.permission !== undefined) {
                        this.viewComment = data.permission
                    } else {
                        this.viewComment = true
                        this.totalAllComments = data.totalAssignmentComments
                    }
                } else {
                    params = {
                        ...params,
                        limit: this.perPage,
                        offset: this.offset,
                    }

                    let data = (await axios.get('/api/v2/comments', { params: params })).data.data
                    if (data.permission !== undefined) {
                        this.viewComment = data.permission
                    } else {
                        this.viewComment = true
                        this.comments = data.comments
                        this.commentsCount = data.total
                        this.totalAllComments = data.totalAssignmentComments
                    }
                }
                this.loadingComments = false
            } catch (err) {
                this.loadingComments = false
            }
        },
    },
}
</script>
<style scoped>
.timeat {
    color: #6f7782;
    font-size: 0.8rem;
    margin-left: 10px;
}

.author > i {
    font-size: 0.8rem;
}
</style>
